import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEpiEcdRootPageContent } from '../../hooks/useEpiEcdRootPageContent';

export function AppNavigation() {
    const ecdRootPage = useEpiEcdRootPageContent();
    const location = useLocation()?.pathname;

    if (!ecdRootPage?.navigationLinks) return null;

    function IsActiveRoute(linkUrl: string): boolean {
        return linkUrl && location?.toLowerCase().includes(linkUrl?.toLowerCase());
    }

    function RenderNavigationLink(props) {
        const { linkUrl, linkText } = props;

        if (!linkText) return null;

        return (<>
            <li key={linkText} className='ecd-nav-list-item'> <a href={linkUrl} className={`ecd-nav-list-item-link ${IsActiveRoute(linkUrl) ? 'active' : ''}`}>{linkText}</a></li>
        </>);
    }

    function RenderNavigationLinks() {
        if (!ecdRootPage?.navigationLinks) return null;

        return (


            <ul className='ecd-nav-list'>
                {ecdRootPage?.navigationLinks?.map((nl) => <RenderNavigationLink key={nl.linkUrl} linkUrl={nl.linkUrl} linkText={nl.linkText} />)}
            </ul>

        );
    }

    return (
        
            <nav className='ecd-nav'>
                <RenderNavigationLinks />
            </nav>
    );
}